const STORAGE_KEY = "checkLab:createInspectionResult";
const DEFAULT_VALUE = false;

function canUseLocalStorage() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

function normalizeStoredValue(value) {
  if (typeof value === "boolean") return value;
  if (value === "true") return true;
  if (value === "false") return false;

  if (typeof value !== "string") return DEFAULT_VALUE;

  try {
    const parsed = JSON.parse(value);
    return typeof parsed === "boolean" ? parsed : DEFAULT_VALUE;
  } catch {
    return DEFAULT_VALUE;
  }
}

export function getCreateInspectionResultPref() {
  if (!canUseLocalStorage()) return DEFAULT_VALUE;

  try {
    const storedValue = window.localStorage.getItem(STORAGE_KEY);
    return storedValue === null
      ? DEFAULT_VALUE
      : normalizeStoredValue(storedValue);
  } catch {
    return DEFAULT_VALUE;
  }
}

export function setCreateInspectionResultPref(value) {
  const normalizedValue = Boolean(value);

  if (!canUseLocalStorage()) return normalizedValue;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizedValue));
  } catch {
    // Storage failures should not block saving the inspection data.
  }

  return normalizedValue;
}
